import { DEFAULT_PROJECT } from 'utils/consts';

const useProjectId = (): string => {
  const listOfPaths = location.pathname.split('/');
  return listOfPaths[1] || DEFAULT_PROJECT.toString();
};

export default useProjectId;
